const NoResultsEvent = new Event('google-search:no-results');

const ResultsLoadedEvent = new Event('google-search:results-loaded');

const GoogleSearchReadyEvent = new Event('google-search:ready');

const GoogleRecaptchaPresentEvent = new Event('google-search:recaptcha');

const SearchSubmittedEvent = new Event('google-search:search-submitted');

const SearchResetEvent = new Event('google-search:search-reset');

const PageUpdatedEvent = (data) => new CustomEvent('google-search:page-updated', {
  detail: data,
});

const SortUpdatedEvent = (data) => new CustomEvent('google-search:sort-updated', {
  detail: data,
});

export default {
  GoogleSearchReadyEvent,
  GoogleRecaptchaPresentEvent,
  NoResultsEvent,
  PageUpdatedEvent,
  ResultsLoadedEvent,
  SearchSubmittedEvent,
  SearchResetEvent,
  SortUpdatedEvent,
};
